<template>
  <div class="pa-4 d-flex align-center">
    <span class="pl-4 grey--text text-subtitle-2"
      >Väntar på svar från Trafikverket</span
    >
  </div>
</template>

<script>
export default {
  name: 'DuaMessageUnknown',

  props: {
    message: {
      type: String,
      default: 'Status: obehandlad'
    }
  }
}
</script>
